/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { JiraHoldoutCustomData } from '@atlassian/holdout-utils/jira-holdout';
import {
	Nav4Projects as Nav4ProjectsWithoutErrorBoundary,
	type Nav4ProjectsProps,
} from './ui/projects/Nav4Projects.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';

export const Nav4Projects = (props: Nav4ProjectsProps): React.JSX.Element => (
	<UFOSegment name="nav4-sidebar-projects">
		<JiraHoldoutCustomData />
		<JSErrorBoundary
			fallback="flag"
			id="projects-section"
			packageName={PACKAGE_NAME}
			teamName={TEAM_NAME}
		>
			<Nav4ProjectsWithoutErrorBoundary {...props} />
		</JSErrorBoundary>
	</UFOSegment>
);
